<main>
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>
  <div class="content">
    <div class="page__title under__line flex items-center justify-between">
      <h1>{{ 'Maintenance_Reports.Title' | translate }}</h1>
      <div>
        <p-button
          [label]="'Maintenance_Reports.Emit_Ticket' | translate"
          icon="pi pi-plus"
          variant="outlined"
          (click)="openEmitTicketModal()"
        ></p-button>
      </div>
    </div>
    <div class="grid grid-cols-12 gap-[2rem]">
      <div class="col-span-12">
        <p-table
          [value]="maintenanceReports()"
          [paginator]="true"
          [rows]="5"
          [rowsPerPageOptions]="[5, 10, 25]"
          selectionMode="single"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="id">
                {{ 'Maintenance_Reports.List_Headers.TicketID' | translate }}
                <p-sortIcon field="id" />
              </th>
              <th pSortableColumn="assetCategoryName">
                {{
                  'Maintenance_Reports.List_Headers.MachineCategory' | translate
                }}
                <p-sortIcon field="assetCategoryName" />
              </th>
              <th pSortableColumn="assetId">
                {{ 'Maintenance_Reports.List_Headers.Machine' | translate }}
                <p-sortIcon field="assetId" />
              </th>
              <th pSortableColumn="maintenanceWorkOrderReasonName">
                {{ 'Maintenance_Reports.List_Headers.Reason' | translate }}
                <p-sortIcon field="maintenanceWorkOrderReasonName" />
              </th>
              <th pSortableColumn="isMachineDown">
                {{
                  'Maintenance_Reports.List_Headers.MachineOperating'
                    | translate
                }}
                <p-sortIcon field="isMachineDown" />
              </th>
              <th pSortableColumn="status">
                {{ 'Maintenance_Reports.List_Headers.Status' | translate }}
                <p-sortIcon field="status" />
              </th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-report>
            <tr>
              <td>{{ report.id }}</td>
              <td>{{ report.assetCategoryName }}</td>
              <td>{{ report.assetId }}</td>
              <td>{{ report.maintenanceWorkOrderReasonName }}</td>
              <td>
                @if (!report.isMachineDown) {
                  <p-tag severity="success" [value]="'Operating' | translate" />
                }
                @if (report.isMachineDown) {
                  <p-tag severity="danger" [value]="'Down' | translate" />
                }
              </td>
              <td>
                @switch (report.status) {
                  @case (MaintenanceWorkOrderStatusEnum.Unclaimed) {
                    <p-tag severity="secondary" [value]="getStatusName(report.status) | translate" />
                  }
                  @case (MaintenanceWorkOrderStatusEnum.Claimed) {
                    <p-tag severity="warn" [value]="getStatusName(report.status) | translate" />
                  }
                  @case (MaintenanceWorkOrderStatusEnum.InProgress) {
                    <p-tag severity="info" [value]="getStatusName(report.status) | translate" />
                  }
                  @case (MaintenanceWorkOrderStatusEnum.Completed) {
                    <p-tag severity="success" [value]="getStatusName(report.status) | translate" />
                  }
                }
              </td>
              <td>
                <button
                  class="btn btn-icon"
                  (click)="openEmitTicketModal(report)"
                >
                  <i class="pi pi-pencil"></i>
                </button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</main>
